import type { ConsentDetails } from '../types/usercentrics';
import { useCookie, useConsentCookie } from './cookies';

declare global {
  interface Window {
    dataLayer: any[];
    __ucCmp?: {
      showSecondLayer: () => void;
    };
  }
}

// Function to open cookie settings
export const openCookieSettings = () => {
  window.__ucCmp?.showSecondLayer();
};

export function usercentricsConsentChange(event: CustomEvent<ConsentDetails>): void {
  const categories = event.detail.categories;

  if (event.detail.consent.type === 'EXPLICIT') {
    const hasSeenCookieBanner = useCookie<boolean>('seenCookieBanner');
    hasSeenCookieBanner.value = true;

    const product = categories?.functional?.state === 'ALL_ACCEPTED';
    const marketing = categories?.marketing?.state === 'ALL_ACCEPTED';
    const necessary = categories?.essential?.state === 'ALL_ACCEPTED';

    const consentCookie = useConsentCookie();
    consentCookie.value = {
      product, marketing, necessary,
    };

    const isRecentlyUpdated = Date.now() - event.detail.consent.updatedAt < 100;

    if (isRecentlyUpdated) {
      window.dataLayer.push({
        event: 'consentInteraction',
        consentInfo: {
          action: 'save settings',
          label: marketing ? 'marketing' : product ? 'product' : 'necessary'
        }
      });
    }
  }
}

export function trackCookieBannerInteraction(event: CustomEvent<{ type: string }>): void {
  if (event.detail.type === 'ACCEPT_ALL') {
    window.dataLayer.push({
      event: 'consentInteraction',
      consentInfo: {
        action: 'approve',
        label: 'marketing'
      }
    });
  }
  if (event.detail.type === 'DENY_ALL') {
    window.dataLayer.push({
      event: 'consentInteraction',
      consentInfo: {
        action: 'deny',
        label: 'product'
      }
    });
  }
  if (event.detail.type === 'MORE_INFORMATION_LINK') {
    window.dataLayer.push({
      event: 'consentInteraction',
      consentInfo: {
        action: 'settings',
      }
    });
  }
}
